import { Box, Typography } from '@mui/material';

import { MODEL_DISCLAIMER_TEXT } from 'src/utils/constants';

function ChatDisclaimer() {
  return (
    <Box component="div" sx={{ mt: '22px', textAlign: 'center' }}>
      <Typography
        component="span"
        fontSize="9px"
        color="text.secondary"
        fontFamily="Roboto Variable"
      >
        <Box>{MODEL_DISCLAIMER_TEXT}</Box>
      </Typography>
    </Box>
  );
}

export default ChatDisclaimer;
